export default function PHP_rmdir() {
  return (
    <div>
      <h1>PHP_rmdir</h1>
    </div>
  );
}
